import { jsx as s } from "react/jsx-runtime";
import n from "classnames";
const a = "forma-ui__buttons-container__root", e = {
  root: a
}, m = ({ className: o, style: r, children: t }) => t ? /* @__PURE__ */ s("div", { className: n(e.root, o && o), style: r, children: t }) : null;
export {
  m as default
};
